// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DayHeading-module__heading___qn6wZ {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
}

.DayHeading-module__quiet___SEprF {
  font-size: 14px;
  color: #71717a;
  white-space: nowrap;
}

.DayHeading-module__rule___A8qJ3 {
  flex: 1;
  min-width: 16px;
  height: 1px;
  background: #e4e4e7;
}`, "",{"version":3,"sources":["webpack://./src/pages/CareOrchestration/components/Visit/DayHeading.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,SAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,mBAAA;AACF;;AAEA;EACE,OAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;AACF","sourcesContent":[".heading {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin: 0;\n}\n\n.quiet {\n  font-size: 14px;\n  color: #71717a;\n  white-space: nowrap;\n}\n\n.rule {\n  flex: 1;\n  min-width: 16px;\n  height: 1px;\n  background: #e4e4e7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"heading": `DayHeading-module__heading___qn6wZ`,
	"quiet": `DayHeading-module__quiet___SEprF`,
	"rule": `DayHeading-module__rule___A8qJ3`
};
module.exports = ___CSS_LOADER_EXPORT___;
